<template>
  <div class="streaks-container">
    <div class="streaks left-streaks"></div>
    <slot></slot>
    <div class="streaks right-streaks"></div>
  </div>
</template>

<script>
import '@/assets/scss/_streaks.scss'

export default {}
</script>
